import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page, Crud } from '../../components'

const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud

export class Frui_qpgoodsPage extends Component {
  static propTypes = {
    furui: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { frui_qpgoodsPage, currentFrui_qpgoods } = this.props.furui;
    this.fetchList(frui_qpgoodsPage);
  }

  fetchList = (page, values) => {
    const { getFrui_qpgoodsList } = this.props.actions;
    let params = Object.assign({}, { page: page }, values)
    getFrui_qpgoodsList(params);
  }

  getDataSource() {
    const { furui } = this.props;
    const { frui_qpgoodsById, frui_qpgoodsList } = furui;
    if (!frui_qpgoodsList) return [];
    return frui_qpgoodsList.map(id => frui_qpgoodsById[id]);
  }

  get listProps() {
    const { furui, actions } = this.props
    const { getFrui_qpgoodsListPending, frui_qpgoodsTotal, frui_qpgoodsPage } = furui
    const { deleteFrui_qpgoods, chooseCurrentFrui_qpgoods, frui_qpgoodsModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qpgoodsListPending,
      columns: [
        {
          title: "序号",
          dataIndex: 'id',
          key: 'id',
          width: 80,
        },
        {
          title: "批号",
          dataIndex: 'ph',
          key: 'ph',
          width: 120,
        },{
          title: "气瓶编号",
          dataIndex: 'bh',
          key: 'bh',
          width: 140,
        },{
          title: "气瓶唯一追溯编号",
          dataIndex: 'wybh',
          key: 'wybh',
          width: 120,
        },{
          title: "公秤容积",
          dataIndex: 'gcrj',
          key: 'gcrj',
          width: 120,
        },{
          title: "制造日期",
          dataIndex: 'zzrq',
          key: 'zzrq',
          width: 120,
        },{
          title: "内胆设计壁厚",
          dataIndex: 'ndsjbh',
          key: 'ndsjbh',
          width: 120,
        },{
          title: "内封头设计厚度",
          dataIndex: 'nftsjhd',
          key: 'nftsjhd',
          width: 120,
        },{
          title: "重量",
          dataIndex: 'weight',
          key: 'weight',
          width: 120,
        },{
          title: "内胆筒体设计厚度",
          dataIndex: 'ndttsjhd',
          key: 'ndttsjhd',
          width: 120,
        },{
          title: "内胆直径",
          dataIndex: 'ndzj',
          key: 'ndzj',
          width: 120,
        },{
          title: "内胆气压试验压力",
          dataIndex: 'ndqysyyl',
          key: 'ndqysyyl',
          width: 120,
        },{
          title: "电子标识",
          dataIndex: 'dzbs',
          key: 'dzbs',
          render: (text) => {
            return <div> <a href='https://file.daries.com.cn/image/newAdd/demo%E5%9B%BE%E7%89%87.pdf'>预览</a> <a>生成</a> </div>
          }
        },{
          title: "钢印截图",
          dataIndex: 'gyjt',
          key: 'gyjt',
          render: (text) => {
            return <div> <a href='https://file.daries.com.cn/image/newAdd/demo%E5%9B%BE%E7%89%87.pdf'>预览</a> </div>
          }
        },{
          title: "产品合格证",
          dataIndex: 'hgz',
          key: 'hgz',
          render: (text) => {
            return<div> <a href='https://file.daries.com.cn/image/newAdd/demo%E5%9B%BE%E7%89%87.pdf'>预览</a> <a>生成</a> </div>
          }
        },
      ],
      pagination: {
        total: frui_qpgoodsTotal,
        current: frui_qpgoodsPage,
        onChange: (page) => {
          this.fetchList(page);
        }
      },
      op: [
        {
          key: 3,
          name: '删除',
          buttonProps: {
            icon: "delete",
            type: "danger"
          },
          needConfirm: true,
          confirmTitle: "确认删除"
        }
      ],
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentFrui_qpgoods(record);
          frui_qpgoodsModalChange(true, "updata");
        } else if (item.key == 3) {
          deleteFrui_qpgoods(record.id).then((data) => {
            this.fetchList(frui_qpgoodsPage);
          })
        }
      }
    }
  }

  get modalProps() {
    const { furui, actions } = this.props
    const { currentFrui_qpgoods, frui_qpgoodsModalVisible, frui_qpgoodsPage, frui_qpgoodsModalType, submitFrui_qpgoodsPending } = furui

    const { frui_qpgoodsModalChange, submitFrui_qpgoods } = actions;
    const editItem = frui_qpgoodsModalType === 'create' ? {} : currentFrui_qpgoods
    return {
      item: frui_qpgoodsModalType === 'create' ? {} : currentFrui_qpgoods,
      visible: frui_qpgoodsModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_qpgoodsPending,
      title: `${
      frui_qpgoodsModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "shopName",
          label: "商户名",
          // initialValue: editItem.shopName,
          widget: Input,
          required: true
        },
        {
          key: "score",
          label: "score",
          // initialValue: editItem.score,
          widget: Input,
          required: true
        },
        {
          key: "subAppid",
          label: "商户公众号id",
          // initialValue: editItem.subAppid,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitFrui_qpgoods(Object.assign({}, data, {})).then(data => {
          frui_qpgoodsModalChange(false, "create");
          this.fetchList(frui_qpgoodsPage);
        })
      },
      onCancel() {
        frui_qpgoodsModalChange(false, "create");
      },
    }
  }

  get filterProps() {
    const { actions, furui } = this.props
    const { currentFrui_qpgoods, frui_qpgoodsPage } = furui
    const { frui_qpgoodsModalChange } = actions;

    return {
      title: "",
      searchElements: [
        {
          key: "loginId",
          widget: Input,
          widgetProps: {
            placeholder: "清输入批号，气瓶编号"
          },
        },
      ],
      onFilterChange: value => {
        this.fetchList(1, value)
      },
      onAdd() {
        frui_qpgoodsModalChange(true, 'create')
      },
    }
  }

  get buttonProps() {
    const { actions, furui } = this.props
    const { currentFrui_qpgoods, frui_qpgoodsPage } = furui
    const { frui_qpgoodsModalChange } = actions;

    return {
      buttons: [
        {
          name: "参数维护",
          buttonProps: {
            type: "primary",
            icon: "plus",
          },
          onClick: () => { frui_qpgoodsModalChange(true, 'create') }
        }, {
          name: '导入excel',
          buttonProps: {
            type: "primary",
            icon: "plus",
          },
          onClick: () => {

          }
        }, {
          name: '导出excel',
          buttonProps: {
            type: "primary"
          },
          onClick: () => {

          }
        } , {
          name: '导出打标文件',
          buttonProps: {
            type: "primary"
          },
          onClick: () => {

          }
        }
      ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    furui: state.furui,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_qpgoodsPage);


// WEBPACK FOOTER //
// ./src/features/furui/Frui_qpgoodsPage.js